import { useEffect } from "react";

import { useAddToCart } from "../hooks/useAddToCart";
import useLocalCart from "../hooks/useLocalCart";
import useSelection from "../lib/Selection/useSelection";

const GiftCardItem = ({ item: oldItem }: { item?: any }) => {
  const { items, location } = useSelection();

  const item = oldItem || items?.[0];
  const { cart } = useLocalCart();
  const { addToCart } = useAddToCart();

  useEffect(() => {
    if ((items?.length === 0 || !items) && cart?.["gift-card"]) {
      addToCart.mutate({
        giftcardId: cart?.["gift-card"] as string,
        amount: cart.type === "anyAmount" ? +(cart?.amount || 0) : undefined,
      });
    }
  }, [items, cart, location?.country]);

  if (!item)
    return (
      <div className="skeleton giftcard-skeleton giftcard-cart-item"></div>
    );

  return (
    <div className="item-preview">
      <p>{item?.totalPrice}</p>
    </div>
  );
};

export default GiftCardItem;
